(() => {
  if (window.__avonleaSiteLoaded) return;
  window.__avonleaSiteLoaded = true;

  const HEADER_SELECTOR = '[data-avl-header]';

  function updateCartCount(itemCount) {
    const count = Number(itemCount);
    if (!Number.isFinite(count) || count < 0) return;

    document.querySelectorAll('[data-avl-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', `Cart with ${count} ${count === 1 ? 'item' : 'items'}`);
      const badge = link.querySelector('[data-avl-cart-count]');
      if (!badge) return;
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  window.avlUpdateCartCount = updateCartCount;

  function initHeader(root) {
    if (!root || root.dataset.avlInitialized === 'true') return;

    const overlay = root.querySelector('[data-avl-menu-overlay]');
    const openButton = root.querySelector('[data-avl-menu-open]');
    const closeButton = root.querySelector('[data-avl-menu-close]');
    const drawer = root.querySelector('[data-avl-menu-drawer]');

    if (!overlay || !openButton || !closeButton || !drawer) {
      root.dataset.avlInitialized = 'true';
      return;
    }

    let lastFocusedElement = null;

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const getFocusable = () => Array.from(drawer.querySelectorAll(focusableSelector))
      .filter((element) => !element.hasAttribute('hidden'));

    const openMenu = () => {
      lastFocusedElement = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('avl-no-scroll');
      document.body.classList.add('avl-no-scroll');

      window.requestAnimationFrame(() => {
        const firstFocusable = getFocusable()[0];
        if (firstFocusable) firstFocusable.focus();
      });
    };

    const closeMenu = ({ restoreFocus = true } = {}) => {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('avl-no-scroll');
      document.body.classList.remove('avl-no-scroll');

      if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    };

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', () => closeMenu());

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeMenu();
    });

    drawer.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => closeMenu({ restoreFocus: false }));
    });

    document.addEventListener('keydown', (event) => {
      if (!overlay.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        closeMenu();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1260 && overlay.classList.contains('is-open')) {
        closeMenu({ restoreFocus: false });
      }
    });

    root.dataset.avlInitialized = 'true';
  }

  function syncMobileDockClass(scope = document) {
    const hasDock = Boolean(scope.querySelector('[data-avl-mobile-dock]') || document.querySelector('[data-avl-mobile-dock]'));
    document.body.classList.toggle('avl-has-mobile-dock', hasDock);
  }

  function initAll(scope = document) {
    scope.querySelectorAll(HEADER_SELECTOR).forEach(initHeader);
    syncMobileDockClass(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', () => syncMobileDockClass());
})();
